import { useEffect } from 'react';
import { useState } from 'react';
import { API_PATH } from '../App';

const { createContext } = require('react');

export const AuthContext = createContext({
  isAuthenticated: false,
  user: null,
  login: () => {},
  logout: () => {},
  register: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  const resetContext = () => {
    setUser(null);
    setIsAuthenticated(null);
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  };

  const login = (loginFormDto) => {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loginFormDto),
    };

    return fetch(`${API_PATH}v1/auth/login`, options)
      .then((response) => response.json())
      .then((result) => {
        if (result?.error?.message) {
          throw new Error(result?.error?.message);
        }
        localStorage.setItem('access_token', result.data.access_token);
        localStorage.setItem('refresh_token', result.data.refresh_token);
        setUser({ username: result.data.username });
        setIsAuthenticated(true);
      });
  };

  const logout = () => {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        refresh_token: localStorage.getItem('refresh_token'),
      }),
    };

    return fetch(`${API_PATH}v1/auth/logout`, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error('HTTP error, status = ' + response.status);
        }
        return response.json();
      })
      .then((result) => {
        if (result.error) throw new Error(result.error);
        resetContext();
      });
  };

  const register = async (registerDto) => {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(registerDto),
    };

    return fetch(`${API_PATH}v1/auth/register`, options)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result?.error?.message) {
          throw new Error(result?.error?.message);
        }
      });
  };

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  const value = { isAuthenticated, user, login, logout, register };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
